(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["hero-advance"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper(".heroSwiperAdvance", {
  loop: true,
  speed: 6000,
  slidesPerView: 2,
  slidesPerGroup: 2,
  autoplay: { delay: 3000, reverseDirection: true },
  pagination: { el: ".swiper-pagination", clickable: true },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  on: {
    slideChangeTransitionStart: function () {
      gsap.killTweensOf(".heroSwiperAdvance .swiper-slide"); // stop previous bounces
      gsap.set(".heroSwiperAdvance .swiper-slide", { y: 0 }); // reset position

      let activeSlide = document.querySelector(".heroSwiperAdvance .swiper-slide-active");
      if (activeSlide) {
        gsap.to(activeSlide, {
          y: "+=15",         // bounce amount
          duration: 1.5,     // speed
          yoyo: true,        // reverse
          repeat: -1,        // infinite
          ease: "sine.inOut" // smooth
        });
      }

      let nextSlide = document.querySelector(".heroSwiperAdvance .swiper-slide-next");
      if (nextSlide) {
        gsap.to(nextSlide, {
          y: "+=15",
          duration: 1.5,
          yoyo: true,
          delay: 0.3,
          repeat: -1,
          ease: "sine.inOut"
        });
      }

    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  if (typeof gsap !== 'undefined') {
    gsap.to(".wave1a", { y: "+=10", duration: 2, yoyo: true, repeat: -1, ease: "sine.inOut" });
    gsap.to(".wave2a", { y: "+=5", duration: 3, yoyo: true, repeat: -1, ease: "sine.inOut" });

    swiper.emit('slideChangeTransitionStart');
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["hero"] && !Shopify.designMode) return;
  try {
    
var swiper = new Swiper(".heroSwiper", {
  loop: true,
  speed: 6000,
  slidesPerView: 2,
  slidesPerGroup: 2,
  autoplay: { delay: 3000, reverseDirection: true },
  pagination: { el: ".swiper-pagination", clickable: true },
  navigation: { nextEl: ".swiper-button-next", prevEl: ".swiper-button-prev" },
  on: {
    slideChangeTransitionStart: function () {
      gsap.killTweensOf(".heroSwiper .swiper-slide"); // stop previous bounces
      gsap.set(".heroSwiper .swiper-slide", { y: 0 }); // reset position

      let activeSlide = document.querySelector(".heroSwiper .swiper-slide-active");
      if (activeSlide) {
        gsap.to(activeSlide, {
          y: "+=15",         // bounce amount
          duration: 1.5,     // speed
          yoyo: true,        // reverse
          repeat: -1,        // infinite
          ease: "sine.inOut" // smooth
        });
      }

      let nextSlide = document.querySelector(".heroSwiper .swiper-slide-next");
      if (nextSlide) {
        gsap.to(nextSlide, {
          y: "+=15",
          duration: 1.5,
          yoyo: true,
          delay: 0.3,
          repeat: -1,
          ease: "sine.inOut"
        });
      }

    }
  }
});

document.addEventListener("DOMContentLoaded", function() {
  if (typeof gsap !== 'undefined') {
    gsap.to(".wave1", { y: "+=10", duration: 2, yoyo: true, repeat: -1, ease: "sine.inOut" });
    gsap.to(".wave2", { y: "+=5", duration: 3, yoyo: true, repeat: -1, ease: "sine.inOut" });

    swiper.emit('slideChangeTransitionStart');
  }
});

  } catch(e) { console.error(e); }
})();
})();
